import logo from '../resources/logo.png'

const FirstPageLogo = () => {
    return (
        <div className="firstpage-logo-cont">
          <img className="firstpage-logo" src={logo} alt="logo"/>
          <span className="firstpage-logo-text">Trivtionary</span>
        </div>
    )
}

export default FirstPageLogo
